module.exports = __webpack_public_path__ + "static/media/business.f0a8561e.png";